import React from "react";
import {
	ShareDownloadsButtonsContainer,
	ShareDownloadsPageWrapper,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import { subscriptionPropTypes } from "@src/propTypes/subscription";
import ShareDownloadsLinks from "./ShareDownloadsLinks";
import ShareDownloadsMinVersion from "./ShareDownloadsMinVersion";
import ShareDownloadsSubscriptionInfo from "./ShareDownloadsSubscriotionInfo";
import { isVersionGreaterOrEqual } from "../utils/versionUtils";
import { DownloadsContextProvider } from "../DownloadsContextProvider";

function ShareDownloadsInfo({ serialNumber }) {
	const productVersion = serialNumber.downloads[0].release || "";
	const { downloads } = serialNumber;

	const isRpmLinksEnabled = isVersionGreaterOrEqual("8.0.3", serialNumber.downloads[0].release);

	return (
		<ShareDownloadsPageWrapper>
			<ShareDownloadsSubscriptionInfo serialNumber={serialNumber} />
			<DownloadsContextProvider isRpmLinksEnabled={isRpmLinksEnabled}>
				<ShareDownloadsButtonsContainer>
					<ShareDownloadsLinks items={downloads} productVersion={productVersion} />
				</ShareDownloadsButtonsContainer>
			</DownloadsContextProvider>
			<ShareDownloadsMinVersion items={downloads} />
		</ShareDownloadsPageWrapper>
	);
}

ShareDownloadsInfo.propTypes = {
	serialNumber: subscriptionPropTypes,
};

export default ShareDownloadsInfo;
